var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.412,
    height: 15.412,
    viewBox: "0 0 15.412 15.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    d: "M257.823.4A7.874,7.874,0,0,0,255,0V3.221Z",
    transform: "translate(-247.294 0)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    d: "M406.712,164.428a7.873,7.873,0,0,0-.4-2.823l-2.823,2.823Z",
    transform: "translate(-391.3 -156.719)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_561_",
    d: "M255,65.9h.641l5.252-5.252a7.285,7.285,0,0,0-.641-.641L255,65.263Z",
    transform: "translate(-247.294 -58.195)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    d: "M319.921,109.629l3.724-3.724a7.253,7.253,0,0,0-.475-.807l-4.531,4.531Z",
    transform: "translate(-309.01 -101.92)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2261_",
    d: "M255,30.729,259.53,26.2a7.238,7.238,0,0,0-.807-.476L255,29.447Z",
    transform: "translate(-247.294 -24.943)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2337_",
    d: "M6.8,29.884l-.513.068A7.254,7.254,0,0,0,1.813,41.939L6.8,36.953Z",
    transform: "translate(0 -28.979)",
    fill: "#5e3787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2340_",
    d: "M81.205,290.006a7.254,7.254,0,0,0,11.987-4.473l.068-.513H86.191Z",
    transform: "translate(-78.751 -276.405)",
    fill: "#5e3787"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqr);
export default __webpack_public_path__ + "static/media/sqr.3d943902145f2449efc322c6dde45a5d.svg";
export { ForwardRef as ReactComponent };